import { render, staticRenderFns } from "./bits.vue?vue&type=template&id=84802b3c"
import script from "./bits.vue?vue&type=script&lang=ts"
export * from "./bits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports